import DOMPurify from "dompurify";
import { templateWith } from "./text-utils.js";
let escapeHTML = (function () {
  var entityMap = {
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&#39;",
    "/": "&#x2F;"
  };
  var re = new RegExp("[&<>\"'/]", "g");
  return function escapeHTML(string) {
    return String(string).replace(re, function (s) {
      return entityMap[s];
    });
  };
})();

const escaped = (strings, ...values) =>
  strings.reduce(
    (acc, cur, idx) =>
      acc + cur + (values.length > idx ? escapeHTML(values[idx]) : ""),
    ""
  );

DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  // set all elements with blank target to noopener
  if ("target" in node && node.getAttribute("target") === "_blank") {
    node.setAttribute("rel", "noreferrer");
  }
});

// https://github.com/cure53/DOMPurify/issues/233 -- extended for newer <use href=>
DOMPurify.addHook("afterSanitizeAttributes", function (node) {
  if (
    node.tagName === "use" &&
    ((node.hasAttribute("xlink:href") &&
      !node.getAttribute("xlink:href").match(/^#/)) ||
      (node.hasAttribute("href") && !node.getAttribute("href").match(/^#/)))
  ) {
    node.remove();
  }
});

const purify = untrusted =>
  DOMPurify.sanitize(untrusted, {
    RETURN_TRUSTED_TYPE: true,
    ADD_ATTR: ["target"],
    ADD_TAGS: ["use"]
  });

const purifyUntyped = untrusted =>
  DOMPurify.sanitize(untrusted, {
    RETURN_TRUSTED_TYPE: false,
    ADD_ATTR: ["target"],
    ADD_TAGS: ["use"]
  });

if (typeof window.trustedTypes === "undefined")
  window.trustedTypes = { createPolicy: (n, rules) => rules };

const justTrustedPolicy = window.trustedTypes.createPolicy("just-trusted", {
  createHTML: input => input
});

const purifyT = templateWith(purifyUntyped);

const purifyTTyped = (...args) =>
  justTrustedPolicy.createHTML(purifyT(...args));

export {
  escapeHTML,
  escaped,
  purify,
  purifyT,
  purifyTTyped,
  purifyUntyped,
  justTrustedPolicy
};
